/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Words_UnitInputs */



/**
* | output |
* | --- |
* | "words" |
*
* @param {Event_Metrics_Words_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_words_unit = /** @type {((inputs?: Event_Metrics_Words_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Words_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("mots")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wörter")
	if (locale === "it") return /** @type {LocalizedString} */ ("parole")
	if (locale === "ru") return /** @type {LocalizedString} */ ("слова")
	if (locale === "es") return /** @type {LocalizedString} */ ("palabras")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言葉")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("palavras")
	return /** @type {LocalizedString} */ ("words")
});